export const ERRORS_EN = {
    Field_Required: 'This field is required.',
    Radio_Button_Required: 'Choose an option to continue.',
    Name_MinRequired: 'Enter at least two letters.',
    Name_ContainsNumbers: 'Name cannot include digits.',
    Name_InvalidCharacters: "This field cannot include a special character that you've entered.",
    CC_NumberInvalid: 'Invalid card number.',
    CC_AmexNotAccepted: "We can't accept American Express.",
    CC_ExpirationInvalidFormat: 'Enter a valid expiration date. Example: MM/YYYY.',
    CC_ExpirationFutureDateRequired: 'Expiration date must be in the future.',
    CVV_InvalidAmex: 'Enter exactly four digits.',
    CVV_InvalidNonAmex: 'Enter exactly three digits.',
    ACH_RoutingNumber_Invalid: 'Routing number should be at least 9 digits.',
    ACH_AccountNumber_Invalid: 'Invalid account number.',
    ACH_AccountDescription_Required: 'This field is required.',
    ACH_AccountDescription_InvalidCharacters: "This field cannot include a special character that you've entered.",
    Address_StreetAddress_MinRequired: 'Enter at least two letters.',
    Address_StreetAddress_InvalidCharacters: "This field cannot include a special character that you've entered.",
    Address_StreetAddress2_InvalidCharacters: "This field cannot include a special character that you've entered.",
    Address_City_MinRequired: 'Enter at least three letters.',
    Address_City_InvalidCharacters: "This field cannot include a special character that you've entered.",
    Address_State_InvalidSelection: 'Please select a valid State.',
    Address_Zip_FiveDigitsRequired: 'Enter exactly five digits.',
    PostalCodeNonUS_InvalidCharacters: "This field cannot include a special character that you've entered.",
    PostalCodeNonUS_MinRequired: 'Enter at least four characters.',
};
//# sourceMappingURL=errors-en.js.map